import { gql, useQuery } from '@apollo/client'
import moment from 'moment'
import { useMemo } from 'react'

import { useDateFilter } from '../../../dateFilter'
import { useGroupFilter } from '../../../groupFilter'
import useListLocationDeliveryKpis, {
  listLocationDeliveryKpisConfigs,
} from '../common/delivery/useListLocationDeliveryKpis'

interface IDataTpye {
  customizedRankLocationDelivery: {
    nodes: {
      totalOrderCount: number
      sumSubtotal: number
      completedDisputeAmount: number
    }[]
  }
}

const query = gql`
  query customDeliveryKpi(
    $iEndDate: Date!
    $iStartDate: Date!
    $iLocationIds: [Int]!
  ) {
    customizedRankLocationDelivery(
      iEndDate: $iEndDate
      iStartDate: $iStartDate
      iFilter: { location_ids: $iLocationIds }
    ) {
      nodes {
        totalOrderCount
        sumSubtotal
        completedDisputeAmount
      }
    }
  }
`

export const bibibopListLocationDeliveryKpisConfigs = {
  ...listLocationDeliveryKpisConfigs,
  totalOrderCount: 'number',
  sumSubtotal: 'price',
  completedDisputeAmount: 'price',
} as const

const YESTERDAY = moment().subtract(1, 'day')

const useBibibopListLocationDeliveryKpis = () => {
  const { data, loading } = useListLocationDeliveryKpis()
  const { startDate, endDate: filterEndDate } = useDateFilter()
  const { groupFilter } = useGroupFilter()
  const endDate = useMemo(
    () =>
      moment(filterEndDate, 'YYYY-MM-DD').isAfter(YESTERDAY)
        ? YESTERDAY.format('YYYY-MM-DD')
        : filterEndDate,
    [filterEndDate],
  )
  const { data: customData, loading: customLoading } = useQuery<IDataTpye>(
    query,
    {
      variables: {
        iStartDate: startDate,
        iEndDate: endDate,
        iLocationIds: groupFilter?.ids,
      },
      skip: !startDate || !endDate || !groupFilter,
    },
  )

  return {
    data: useMemo(() => {
      const deliveryData = customData?.customizedRankLocationDelivery.nodes[0]

      if (!data || !deliveryData) return null

      return {
        ...data,
        ...deliveryData,
      }
    }, [data, customData]),
    loading: loading || customLoading,
  }
}

export default useBibibopListLocationDeliveryKpis
